import { AcquisitionFlow, getAcquisitionFlow } from '../../../utils/acquisition-utils';

const nameSectionErrorOrder = [
    ['FirstName', 'RequiredField'],
    ['FirstName', 'NotValid'],
    ['MiddleInitial', 'RequiredField'],
    ['MiddleInitial', 'NotValid'],
    ['LastName', 'RequiredField'],
    ['LastName', 'NotValid'],
    ['NameSuffix', 'RequiredField'],
];

const mailingAddressSectionErrorOrder = [
    ['MailingAddressLine1', 'RequiredField'],
    ['MailingAddressLine1', 'NotValid'],
    ['MailingAddress', 'NotEligible'],
    ['MailingAddressLine2', 'NotValid'],
    ['AddrAndAptNumMatch', 'NotValid'],
    ['MailingCity', 'RequiredField'],
    ['MailingCity', 'NotValid'],
    ['MailingState', 'RequiredField'],
    ['MailingZipCode', 'RequiredField'],
    ['StateZipCombination', 'NotValid'],
];

const homeAddressSectionErrorOrder = [
    ['IsMailingHomeAddressSame', 'RequiredField'],
    ['HomeAddressLine1', 'RequiredField'],
    ['HomeAddressLine1', 'NotValid'],
    ['HomeAddressLine2', 'NotValid'],
    ['HomeAddress', 'NotValid'],
    ['HomeAddrAndAptNumMatch', 'NotValid'],
    ['HomeCity', 'NotValid'],
    ['HomeCity', 'RequiredField'],
    ['HomeState', 'RequiredField'],
    ['HomeZipCode', 'RequiredField'],
    ['HomeStateZipCombination', 'NotValid'],
];

const paContactAndFinancialSectionErrorOrder = [
    ['EmailAddress', 'RequiredField'],
    ['EmailAddress', 'NotValid'],
    ['EmailAddress', 'ThirdParty'],
    ['PrimaryPhoneNumber', 'RequiredField'],
    ['PrimaryPhoneNumber', 'NotValid'],
    ['PrimaryPhoneNumber', 'ThirdParty'],
    ['Ssn', 'RequiredField'],
    ['Ssn', 'NotValid'],
    ['DateOfBirth', 'RequiredField'],
    ['DateOfBirth', 'NotValid'],
    ['DateOfBirth', 'NotEligible'],
    ['Under19YearDOB', 'NotEligible'],
    ['MonthlyIncome', 'RequiredField'],
    ['MonthlyIncome', 'NotValid'],
];

const skipPqContactAndFinancialSectionErrorOrder = [
    ['PrimaryPhoneNumber', 'RequiredField'],
    ['PrimaryPhoneNumber', 'NotValid'],
    ['PrimaryPhoneNumber', 'ThirdParty'],
    ['EmailAddress', 'RequiredField'],
    ['EmailAddress', 'NotValid'],
    ['EmailAddress', 'ThirdParty'],
    ['Ssn', 'RequiredField'],
    ['Ssn', 'NotValid'],
    ['DateOfBirth', 'RequiredField'],
    ['DateOfBirth', 'NotValid'],
    ['DateOfBirth', 'NotEligible'],
    ['Under19YearDOB', 'NotEligible'],
    ['MonthlyIncome', 'RequiredField'],
    ['MonthlyIncome', 'NotValid'],
];

const pqContactAndFinancialSectionErrorOrder = [
    ['PrimaryPhoneNumber', 'RequiredField'],
    ['PrimaryPhoneNumber', 'NotValid'],
    ['PrimaryPhoneNumber', 'ThirdParty'],
    ['MonthlyIncome', 'RequiredField'],
    ['MonthlyIncome', 'NotValid'],
];

const phaContactAndFinancialSectionErrorOrder = [
    ['Ssn', 'RequiredField'],
    ['Ssn', 'NotValid'],
];

const cardDesignSectionErrorOrder = [
    ['SelectedCardId', 'RequiredField'],
];

const creditProtectionSectionErrorOrder = [
    ['IsCreditProtectionSelected', 'RequiredField'],
    ['CreditProtectionInitials', 'RequiredField'],
];

const authorizedUserSectionErrorOrder = [
    ['IsAuthorizedUserSelected', 'RequiredField'],
    ['AuthorizedUserFirstName', 'RequiredField'],
    ['AuthorizedUserFirstName', 'NotValid'],
    ['AuthorizedUserLastName', 'RequiredField'],
    ['AuthorizedUserLastName', 'NotValid'],
    ['AuthorizedUserMiddleInitial', 'NotValid'],
    ['AuthorizedUserDateOfBirth', 'RequiredField'],
    ['AuthorizedUserDateOfBirth', 'NotValid'],
    ['AuthorizedUserDateOfBirth', 'NotEligible'],
    ['IsAuthorizedUserSpouse', 'RequiredField'],
];

const contactAndFinancialSectionErrorOrder = (flow: AcquisitionFlow) => {
        switch (flow) {
            case AcquisitionFlow.SkipPQ:
                return skipPqContactAndFinancialSectionErrorOrder;
            case AcquisitionFlow.PqOfOne:
            case AcquisitionFlow.PQ:
                return pqContactAndFinancialSectionErrorOrder;
            case AcquisitionFlow.PHA:
                return phaContactAndFinancialSectionErrorOrder;
            case AcquisitionFlow.PA:
            default:
                return paContactAndFinancialSectionErrorOrder;
        }
};

export default (
    pushdownErrorArray: [string, string][],
): [string, string][] => {
    const flow = getAcquisitionFlow();

    const sortOrder = [
        flow === AcquisitionFlow.SkipPQ ? cardDesignSectionErrorOrder : [],
        nameSectionErrorOrder,
        mailingAddressSectionErrorOrder,
        homeAddressSectionErrorOrder,
        contactAndFinancialSectionErrorOrder(flow),
        flow !== AcquisitionFlow.SkipPQ ? cardDesignSectionErrorOrder : [],
        creditProtectionSectionErrorOrder,
        authorizedUserSectionErrorOrder,
    ].flat();
    const output = new Array(sortOrder.length).fill(null);

    // place error in correct index
    pushdownErrorArray.forEach(message => {
        const newIndex = sortOrder.findIndex(
            correctMessage =>
                correctMessage[0] === message[0] &&
                correctMessage[1] === message[1],
        );
        output[newIndex] = message;
    });

    return output.filter(message => message !== null);
}
